import moment from 'moment';

import { IorderItem } from '@/redux/reducers/order';
import http from './http';

// 会员卡邀请单生成
export const fetchGenerateMemberCardQrcode = () => {
  return http({
    url: `/member-card-qrcode/generate`,
  });
};

// 房间订单查询
export const fetchQueryRoomOrderPage = (data) => {
  return http({
    method: 'POST',
    url: `/orders/room-orders`,
    data,
  });
};

// 获取指定时间对应营业日
export const fetchGetBatchBusinessDate = (data) => {
  return http({
    method: 'POST',
    url: `/sys/batch/future-business-date`,
    data,
  });
};

// 账务查询导出
export const fetchExportBillList = (data) => {
  return http({
    method: 'POST',
    url: `/bills/items/query/export`,
    data,
    responseType: 'blob',
  });
};

// 账务查询
export const fetchQueryBillPage = (data) => {
  return http({
    method: 'POST',
    url: `/bills/items/query/page`,
    data,
  });
};
// 根据主单号查询主单
export const fetchOrderDetailByResvNo = (data) => {
  return http({
    url: `/orders/resv/info/${data.resvNo}`,
  });
};

// 直连退单占用单号
export const fetchQueryCancelOta = (data) => {
  return http({
    method: 'POST',
    url: `/sub/order/ota/cancel-mark-query`,
    data,
  });
};

// 直联退单标记允许退单
export const fetchCancelOta = (data) => {
  return http({
    method: 'POST',
    url: `/sub/order/ota/cancel-mark`,
    data,
  });
};

// 直连退单查询
export const fetchOtaCancelList = (data) => {
  return http({
    method: 'POST',
    url: `/sub/order/ota/cancel-list`,
    data,
  });
};

// 检查用户是否入住中
export const fetchCurrentCheckinStatus = (data) => {
  return http({
    method: 'POST',
    url: `/sub-order-occ/user/identity`,
    data,
  });
};

// 检查是否产生夜审自动房费，能否更换房主
export const fetchIsChangeMaster = (params) => {
  return http({
    url: `/order/detail/change-master/check/${params.resvNo}`,
  });
};

// 设为房主
export const fetchBecomeMatser = (params) => {
  return http({
    url: `/order/detail/become-master/${params.id}`,
  });
};

// 设为房主V2
export const fetchBecomeMasterV2 = (data) => {
  return http({
    method: 'POST',
    url: '/order/detail/become-master-v2',
    data,
  });
};

// 查询门店是否启用房卡
export const fetchIsStartUseCard = () => {
  return http({
    url: `/lock/vendor/hotel/one`,
  });
};

// 续住明细
export const fetchExtendedCheckinDetail = (data) => {
  return http({
    url: `/order/detail/${data.recNo}/extensions`,
  });
};

// 修改续住单号
export const fetchUpdateExtendedCheckinDetail = (data) => {
  return http({
    method: 'put',
    url: `/order/detail/extension`,
    data,
  });
};

// 获取营业日
export const fetchCurrentSysTime = () => {
  return http({
    url: '/sys/current',
  });
};

// 指定时间所在营业日 20240420更新到v2
export const fetchSysBusinessDateByTime = (params) => {
  const dateTime = moment(params.time).valueOf();
  return http({
    method: 'POST',
    url: '/sys/futureV2',
    data: { dateTime },
  });
};

// 获取上次夜审时间
export const fetchLastNightAudit = () => {
  return http({
    url: '/sys/night-audit/last',
  });
};

// 查询入住单列表
export const fetchOrderCheckedInList = (data) => {
  return http({
    method: 'post',
    url: '/orders/checked-in',
    data,
  });
};

// 查询已退房分页
export const fetchOrderCheckedOutPage = (data) => {
  return http({
    method: 'post',
    url: '/orders/checked-out',
    data,
  });
};

// 查询预订单列表
export const fetchOrderReservedList = (data) => {
  return http({
    method: 'post',
    url: '/orders/reserved',
    data,
  });
};

// 查询预订取消分页
export const fetchOrderCanceledPage = (data) => {
  return http({
    method: 'post',
    url: '/orders/canceled',
    data,
  });
};

// 订单基本信息
export const fetchOrderDetailBaseInfo = (params: IorderItem) => {
  return http({
    method: 'get',
    url: `/order/detail/${params.resvNo}/summary`,
  });
};

// 宾客详情
export const fetchOrderCustomerInfo = (params: IorderItem) => {
  return http({
    method: 'get',
    url: `/order/detail/${params.resvNo}/customer`,
  });
};

// // 宾客备注修改
// export const fetchUpdateOrderCustomerInfo = (data: IcustomerInfo) => {
//   return http({
//     method: 'put',
//     url: `/order/detail/customer/edit/remark`,
//     data,
//   });
// };

// 房间详情
export const fetchOrderRoomInfo = (params: IorderItem) => {
  return http({
    method: 'get',
    url: `/order/detail/${params.resvNo}/room`,
  });
};

// 订单备注修改
export const fetchUpdateOrderRemark = (data) => {
  return http({
    method: 'put',
    url: `/order/detail/sub-order`,
    data,
  });
};

// 修改房间价格、押金
export const fetchUpdateRoomPrice = (data) => {
  return http({
    method: 'put',
    url: `/order/detail/price-deposit`,
    data,
  });
};

// 添加人
export const fetchAddMember = (data) => {
  return http({
    method: 'post',
    url: `/order/detail/member`,
    data,
  });
};

// 修改人
export const fetchUpdateMember = (data) => {
  return http({
    method: 'put',
    url: `/order/detail/member`,
    data,
  });
};

// 修改预订人
export const fetchUpdateBooker = (data) => {
  return http({
    method: 'put',
    url: `/order/detail/booker`,
    data,
  });
};

// 离店
export const fetchMemberCheckOut = (data) => {
  return http({
    method: 'put',
    url: `/order/detail/${data.id}/member/check-out`,
    data,
  });
};

// 联房详情
export const fetchUniteRoomDetail = (data) => {
  return http({
    url: `/join/rooms/${data.resvNo}/detail`,
  });
};

// 确认联房
export const fetchSubmitUniteRoom = (data) => {
  return http({
    method: 'post',
    url: `/join/rooms/submit`,
    data,
  });
};

// 拆房详情
export const fetchSplitRoomDetail = (data) => {
  return http({
    method: 'post',
    url: `/join/rooms/split/detail`,
    data,
  });
};

// 拆房提交
export const fetchSubmitSplitRoom = (data) => {
  return http({
    method: 'post',
    url: `/join/rooms/split/submit`,
    data,
  });
};

// 获取账单列表
export const fetchBillList = (data) => {
  return http({
    url: '/bills/items/search',
    method: 'POST',
    data,
  });
};

// 获取查房列表
export const fetchCheckRoomList = (params) => {
  return http({
    url: `/check-room/list/${params.resvNo}`,
  });
};

// 检查房间状态
export const fetchVerificationCheckRoom = (data) => {
  return http({
    url: '/check-room/verification',
    method: 'POST',
    data,
  });
};

// 申请查房
export const fetchApplyCheckRoom = (data) => {
  return http({
    url: '/check-room/apply',
    method: 'POST',
    data,
  });
};

// 获取催单房间列表
export const getOrderUrgeList = (data) => {
  return http({
    url: '/sub/order/urge/list',
    method: 'POST',
    data,
  });
};

// 发起催单
export const pushUrgeMessage = (data) => {
  return http({
    url: '/sub/order/urge/msg/push',
    method: 'POST',
    data,
  });
};

// 获取订单基本信息
export const getOrderBaseInfo = (params) => {
  return http({
    url: '/orders/info',
    method: 'GET',
    params,
  });
};

// 获取订单日志
export const getOrderLogByPage = (data) => {
  return http({
    url: '/logs/order-log/page',
    method: 'POST',
    data,
  });
};

// 获取日志详情
export const getOrderLogDetail = (params) => {
  return http({
    url: '/logs/order-log/detail',
    method: 'GET',
    params,
  });
};

// 导出日志列表
export const exportOrderLog = (data) => {
  return http({
    url: '/logs/order-log/export',
    method: 'POST',
    responseType: 'blob',
    data,
  });
};
